(function ($) {


  $(window).on('resize', function () {
    // console.log('note loaded');
    if (!$('.nhsnote-box__close-wrapper').length) {
      $('.nhsnote-box__close').wrap('<div class="nhsnote-box__close-wrapper"></div>');
    }

    $('.nhsnote-box__inner').css('top', $('header.header').outerHeight());

    $('.ns-table table').each(function () {
      /*if(arrayContains($(this).parent().attr('tableid'), nosplit)){
        $(this).parents('.ns-table-wrap').addClass('nosplit')
      }*/
      var colCount = $(this).find('tbody tr:nth-of-type(3) td').length;
      if (colCount < 4) {
        $(this).parents('.ns-table-wrap').addClass('nosplit');
      }
      if (colCount > 7) {
        $(this).parents('.ns-table-wrap').addClass('js-table-early-break');
      }
    });

  });

  $('.ns-table .head .note').each(function () {
    $(this).removeClass('note');
  });

  $(document).on('noteClosed', function () {
    // console.log('noteClosed-Event');
    $('html, body').removeClass('notes-open');
  });

})(jQuery);
